import useAccountDetailSSO from '@hooks/useAccountDetailsSSO';
import { config } from 'config';
import React, { useEffect, useRef } from 'react';
import { AuthenticationLoader } from '../atoms/loading';

type LoanType = 'oneTimePayment' | 'recurringPayments' | 'paymentHistory' | 'statements';
interface PaymentCareProps {
    careType?: LoanType;
}
const AccountCare: React.FC<PaymentCareProps> = ({ careType = null }) => {
    const formRef = useRef<HTMLInputElement>(null);
    const targetMenu = careType?.length ? `?target_menu=${careType}` : '';
    const { ssoData, loading, error } = useAccountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost${targetMenu}`);

    useEffect(() => {
        if (ssoData?.url && ssoData?.token) {
            formRef.current.click();
        }
    }, [ssoData?.url, ssoData?.token]);

    if (error) {
        console.error(error);
    }
    if (loading) return <AuthenticationLoader />;
    return (
        <form method="post" action={ssoData?.url}>
            <input type="hidden" value={ssoData?.token} name="Token" />
            <input type="submit" ref={formRef} hidden />
        </form>
    );
};

export default AccountCare;
